export const features = {
	"action: card draw": /draw.*card/,
	"action: life gain": /gain(s)? (\d+ life|life)/,
	"action: add mana": /add \{.*\}|add one mana of any color/,
	"action: search library": /search your library/,
	"action: create tokens": /create .* token/,
	"action: counter spell": /counter target spell/,
	"action: return to hand": /return.*to (its owner'?s)? hand/,
	"action: destroy": /destroy target/,
	"action: exile": /exile/,
	"action: sacrifice": /sacrifice/,
	"action: gain control": /gain control of (target )?\b(creature|permanent)/,
	"action: deal damage": /deals? .* damage to/,
	"action: put onto battlefield": /put .+ onto the battlefield/,
	"action: put counters": /(put(s)? (\d+|\w+) \+(\d+\/\d+)|a \-1\/\-1) counter(s)? on (target|each|a|your)/,
	"action: discard cards": /(discard).*(card)/,
	"action: mill cards": /mill (\w+ cards|two cards|three cards|four cards|five cards|six cards|seven cards|eight cards|nine cards|ten cards)/,
	"action: scry": /scry [0-9]+/,
	"action: clash": /clash with an opponent/,
	"action: copy": /(copy target .+|you may copy)/,
	"action: tap or untap": /tap|untap/,
	"effect: haste": /haste/,
	"effect: flying": /flying/,
	"effect: first strike": /first strike/,
	"effect: trample": /trample/,
	"effect: vigilance": /vigilance/,
	"effect: menace": /menace/,
	"effect: landwalk": /.+walk/,
	"effect: flash": /flash/,
	"effect: hexproof": /hexproof/,
	"effect: protection": /protection from/,
	"effect: prowess": /prowess/,
	"effect: lifelink": /(has|gains) lifelink/,
	"effect: ward": /ward(—|\{.+\})?/,
	"effect: indestructible": /indestructible/,
	"effect: can't be blocked": /can't be blocked/,
	"effect: deathtouch": /(has|gains) deathtouch/,
	"trigger: enters battlefield": /when .* enters the battlefield/,
	"trigger: dies": /when .* dies/,
	"trigger: attacks": /whenever .* attacks/,
	"trigger: becomes blocked": /whenever .* becomes blocked/,
	"trigger: deals damage": /(when|whenever|if) .+ deals (combat )?damage/,
	"trigger: upkeep": /at the beginning of your upkeep/,
	"trigger: draws card": /(when|whenever|if) you draw a card/,
	"trigger: discards card": /(when|whenever|if) .+ discards a card/,
	"trigger: landfall": /landfall —/,
	"trigger: spell cast": /whenever you cast a spell/,
	"trigger: cycle or discard": /whenever you cycle or discard/,
	"trigger: sacrifices": /(when|whenever|if) .+ sacrifices .+/,
	"effect: hexproof player": /you have hexproof/,
	"trigger: creature enters battlefield your control": /whenever a creature enters the battlefield under your control/,
	"action: counter placement": /(put|placing) a \+\d\/\+\d counter on|gets? \+\d\/\+\d until end of turn/,
	"action: permanent destruction": /destroy target (creature|artifact|land|permanent)/,
	"action: damage": /deals? (\d+ damage|that much damage|damage equal to its power|1 damage to|2 damage|3 damage)/,
	"effect: alternative cost": /may be paid with any combo of/,
	"effect: cost reduction": /costs? \{.*\} less to cast/,
	"effect: reach": /reach/,
	"effect: artifact to creature": /is a creature in addition to its other types/,
	"effect: mana generation": /{T}: .*add \{\w\}|{T}: Add \{\w\}/,
	"trigger: beginning of your end step": /at the beginning of your end step/,
	"trigger: deals combat damage": /whenever .* deals combat damage/,
	"effect: convoke": /convoke/,
	"effect: double strike": /double strike/,
	"action: token creation": /create[sd]?[a-zA-Z\s]*token[s]?/,
	"action: land search": /search your library .*for a basic land card/,
	"trigger: you gain life": /whenever you gain life/,
	"action: mana spending freedom": /you may spend mana as though it were mana of any color/,
	"action: opponent discards": /target opponent discards/,
	"effect: sacrifice for effect": /sacrifice.*:/,
	"action: creature fight": /fights/,
	"action: mill": /(mill).*(card)/,
	"effect: defender": /\bdefender\b/,
	"action: shuffle into library": /shuffle .* into .* library/,
	"trigger: activated ability used": /whenever you activate/,
	"action: discard": /(discard(s)? a card|discards (two cards|their hand|a card|your hand|their hands))/,
	"effect: megamorph": /megamorph/,
	"effect: morph": /morph/,
	"action: life payment": /pay \d+ life/,
	"action: proliferate": /proliferate/,
	"trigger: land enters battlefield under your control": /land enters the battlefield under your control/,
	"action: change turn order": /reverse the game's turn order/,
	"effect: rampage": /rampage \d+/,
	"effect: copy spell": /copy .* spell/,
	"effect: copy ability": /copy .* ability/,
	"effect: suspend": /suspend/,
	"action: exile and cast": /you may cast .* without paying its mana cost/,
	"action: create token": /create.*token/,
	"action: life loss": /lose(s)? (\d+ life|1 life|2 life|3 life|4 life|5 life)/,
	"effect: shroud": /shroud/,
	"trigger: land enters battlefield": /whenever a .* land enters the battlefield|when .* land enters the battlefield under .* control/,
	"trigger: attack": /whenever[a-zA-Z\s]*attacks?/,
	"trigger: creature enters battlefield": /whenever a creature enters the battlefield/,
	"trigger: cast spell": /whenever you cast/,
	"trigger: deal combat damage": /whenever .* deals? combat damage/,
	"trigger: beginning of upkeep": /at the beginning of your upkeep/,
	"action: untap": /untap (a|an|the|) (target\s+|your\s+|all\s+|)(creatures?|land|)/,
	"action: tap": /tap (an? |untapped )?(creature|creatures|permanent|artifacts?|land)/,
	"effect: renown": /renown/,
	"effect: partner": /partner/,
	"effect: equip": /equip/,
	"effect: landfall": /\blandfall —/,
	"effect: exalted": /\bexalted\b/,
	"effect: heroic": /\bheroic —/,
	"effect: echo": /echo(?![\s\S]*\becho\b[\s\S]*\becho\b)/,
	"effect: madness": /madness/,
	"effect: dash": /dash/,
	"effect: join forces": /\bjoin forces\b/,
	"effect: domain": /\bdomain\b/,
	"effect: fabricate": /fabricate/,
	"effect: cohort": /\bcohort —/,
	"effect: cleave": /\bcleave\b/,
	"effect: afflict": /\bafflict\b/,
	"effect: changeling": /changeling/,
	"effect: storm": /\bstorm/,
	"effect: buyback": /\bbuyback\b/,
	"effect: fuse": /fuse(?! counter)/,
	"effect: cycling": /\bcycling\b/,
	"effect: kicker": /kicker/,
	"trigger: cast historic spell": /whenever you cast a historic spell/,
	"trigger: sacrifice": /sacrifice(s|d|) (a|an|the|another|any number of|all|) ?(creature|creatures|artifact|artifacts|permanent|permanents|land|lands|) ?(or|and|) ?(creature|creatures|artifact|artifacts|permanent|permanents|land|lands|)?/,
	"effect: monstrosity": /monstrosity/,
	"trigger: modified creatures attack": /whenever one or more modified creatures you control attack/,
	"action: add counters": /put[s]? (\w+ )?\+1\/\+1 counter[s]? on/,
	"action: discard card": /discards? a card/,
	"action: prevent damage": /prevent (the next)? [0-9X]+ damage/,
	"effect: attack restriction": /(can't|cannot) (be blocked|attack)/,
	"effect: casting cost reduction": /cost[s]? {1} less to cast/,
	"effect: combat damage prevention": /prevent all combat damage/,
	"effect: destroy": /(destroy target|destroy all)/,
	"effect: enters tapped": /enters the battlefield tapped/,
	"effect: mana ability": /\bT\b.*: add/,
	"effect: power toughness boost": /get[s]? \+\d\/\+\d/,
	"effect: toughness assignment": /toughness is equal to/,
	"trigger: attack alone": /whenever .* attacks alone/,
	"trigger: battlefield trigger": /when .* enters the battlefield/,
	"trigger: block or blocked": /whenever .* blocks or becomes blocked/,
	"trigger: combat damage to player": /whenever .* deals combat damage to a player/,
	"trigger: discard": /whenever you discard/,
	"trigger: draw step": /after your draw step/,
	"trigger: exile": /if .* would be exiled/,
	"trigger: graveyard trigger": /from your graveyard/,
	"trigger: land enters": /whenever a land enters the battlefield/,
	"trigger: life gain": /whenever you gain life/,
	"trigger: noncreature spell": /whenever you cast a noncreature spell/,
	"trigger: spell or ability targets you": /whenever you( or .*)? become the target of (a spell or ability)/,
	"trigger: spell or ability targets": /whenever .* becomes the target of a spell or ability/,
	"trigger: tapped": /whenever a .* enters the battlefield tapped/,
	"trigger: upkeep trigger": /at the beginning of your upkeep/,
	"action: return from graveyard": /return.*from your graveyard/,
	"action: mana generation": /add(s)?\s\{\D?[\dXGWRBU]+([,\/]\D?[\dXGWRBU]+)*\}\s*to\syour\smana\s*pool/,
	"effect: enchantment": /enchant(s|ed|ment|ing)?\b/,
	"trigger: at upkeep": /at\sthe\sbeginning\sof\sy?o?ur?\supkeep/,
	"trigger: at end step": /at\sthe\sbeginning\sof\sthe\send\sstep/,
	"trigger: on block": /whenever\s[a-zA-Z\s]*blocks?/,
	"trigger: gain life": /whenever you gain life/,
	"trigger: creature token enters": /whenever\s[a-zA-Z\s]*\s*creature\s*token\s*enters\sthe\sbattlefield/,
	"effect: can't gain life": /can'?t gain life/,
	"trigger: lands enter": /whenever a land enters the battlefield/,
	"trigger: combat damage": /deals combat damage/,
	"trigger: end step": /at the beginning of each end step/,
	"trigger: mutate": /whenever this creature mutates/,
	"trigger: opponent's end step": /at the beginning of each opponent's end step/,
	"trigger: begin combat": /at the beginning of combat on your turn/,
	"trigger: draw cards": /if you drew two or more cards this turn/,
	"trigger: creature targeted": /whenever .* becomes the target/,
	"trigger: spell or ability target": /becomes the target of a spell or ability/,
	"trigger: attacks or blocks": /whenever .* attacks or blocks/,
	"trigger: search library": /whenever an opponent searches their library/,
	"trigger: cast instant or sorcery": /whenever you cast or copy an instant or sorcery spell/,
	"trigger: cast aura or equipment": /whenever you cast an aura or equipment spell,?/,
	"trigger: creature power": /target creature gets \+\d+\/\+\d+ until end of turn/,
	"trigger: change base power": /base power and toughness/,
	"action: copy spell": /copy (that|the) spell/,
	"action: transform": /transform/,
	"action: deal combat damage": /deals combat damage/,
	"action: equip": /equip/,
	"trigger: if kicked": /if .* was kicked/,
	"effect: snow": /(snow )?lands?/,
	"action: attach": /(attach(ing|es)?)/,
	"effect: unblockable": /can't be blocked/,
	"trigger: if cast for cost": /if .* was .* cost/,
	"action: reduce cost": /cost(s|ing)?(.*?)([0-9]|one|two|three|four|five|six|seven|eight|nine|ten) less to cast/,
	"effect: cumulative upkeep": /cumulative upkeep/,
	"effect: can't be blocked by power": /can't be blocked by creatures with power \d or less/,
	"effect: increase power": /gets \+\d+\/\+\d+ (as long as|if|until|whenever)/,
	"effect: activated abilities": /activated abilities(?! can't be activated)/,
	"effect: no max hand size": /no maximum hand size/,
	"action: puts card in library": /(put.*on (the )?bottom.*library)/,
	"trigger: spell has flashback": /flashback/,
	"action: choose one": /choose one —/,
	"action: cast from graveyard": /(cast it from your graveyard)/,
	"action: melds into": /melds with/,
	"effect: modification": /modified/,
	"action: investigate": /investigate/,
	"trigger: spellbook": /draft a card from .* spellbook/,
	"action: draw cards": /(draw).*(card)/,
	"action: shuffle": /shuffle/,
	"trigger: when cast": /when you cast/,
	"trigger: when enters battlefield": /when .* enters the battlefield/,
	"trigger: when dies": /when .* dies/,
	"trigger: when attacks": /whenever.*attacks/,
	"trigger: when deals combat damage": /whenever.*deals combat damage/,
	"trigger: when creature dies": /whenever a creature dies/,
	"modifier: as long as": /as long as/,
	"modifier: choose one or both": /choose one or both/,
	"modifier: choose two": /choose two/,
	"modifier: other creatures get": /other creatures you control get/,
	"modifier: creatures can't block": /creatures can't block/,
	"modifier: can't be blocked": /can't be blocked/,
	"modifer: can't cast spells": /can't cast spells/,
	"condition: additional cost to cast": /as an additional cost to cast this spell,/,
	"condition: if you control": /if you control/,
	"condition: if you gained life": /if you gained life/,
	"condition: if you have": /if you have/,
	"action: double counters": /double the number of .* counters/,
	"trigger: when you scry": /whenever you scry/,
	"trigger: when you roll a die": /whenever you roll a die/,
	"effect: can't activate abilities": /can't activate abilities/,
	"action: deal damage to each": /deals [0-9]+ damage to each/,
	"condition: if devotion to": /if your devotion to/,
	"action: attach to creature": /attach.*to target creature/,
	"trigger: when you gain life": /whenever you gain life/,
	"trigger: when sacrifices": /whenever you sacrifice/,
	"trigger: when target": /whenever.*target/,
	"modifier: gains ability until end of turn": /gains .* until end of turn/,
	"modifier: has ability as long as": /has .* as long as/,
	"effect: all creatures get": /all creatures get/,
	"trigger: when leaves battlefield": /when.*leaves the battlefield/,
	"action: roll a die": /roll a/,
	"effect: gains control": /gain control of/,
	"action: gain life": /gain.*life/,
	"action: creature exile": /exile.*target creature/,
	"action: damage to opponents": /deals [0-9X]+ damage to each opponent/,
	"action: destroy target": /(destroy) (target) [a-z]+/,
	"action: creature gets bonus": /target creature gets \+\d\/\+\d/,
	"trigger: creature ETB": /whenever (a|another) creature enters the battlefield/,
	"trigger: on attack": /whenever (.* )?attacks(,)?/,
	"trigger: on spell cast": /whenever you cast (a|an)/,
	"trigger: on combat damage": /when .* deals combat damage/,
	"trigger: on equip": /whenever equipped creature dies/,
	"trigger: on landfall": /landfall —/,
	"trigger: on death": /when .* dies/,
	"modifier: cost reduction": /costs? \{[0-9X]+\} less to cast/,
	"modifier: search library": /search your library/,
	"trigger: on discard": /if you discard/,
	"action: tap target": /tap target | tap up to/,
	"trigger: at the beginning of upkeep": /at the beginning of your upkeep/,
	"modifier: gain control": /gain control of target/,
	"modifier: exchange control": /exchange control of/,
};

export function getFeatures(names) {
	if (!names) return Object.entries(features);

	const results = [];
	for (const name of names) {
		if (features[name]) results.push([name, features[name]]);
	}

	return results;
}

export function matchingFeatures(card, names) {
	const matches = [];
	for (const [feature, regex] of getFeatures(names)) {
		if (card.text?.match(regex)) {
			matches.push(feature);
		}
	}
	return matches;
}

export function cardHasFeature(card, feature) {
	const regex = features[feature];
	return Boolean(regex) && card.text.match(regex);
}

export function cardHasFeatures(card, featuresToMatch) {
	return featuresToMatch.every(feature => cardHasFeature(card, feature));
}
